import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '@dss-libs/shared/ui/common-components';

@Component({
  selector: 'juno-libs-ui-manage-subscriptions-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './manage-subscriptions-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageSubscriptionsSkeletonComponent {}
